export default function last<T>(arr: T[]): T | undefined {
  const len = arr.length;
  return len ? arr[len - 1] : undefined;
}
